import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {DateAdapter, ErrorStateMatcher, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-tavi-center-dialog',
  templateUrl: './tavi-center-dialog.component.html',
  styleUrls: [ './tavi-center-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})
export class TaviCenterDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher(); // 
  public entityForm: FormGroup;
  public isEdit: boolean = false;

  constructor (
    public matDialogRef: MatDialogRef<TaviCenterDialogComponent>,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    //console.log("dialog data: " + JSON.stringify(this.data));
    this.entityForm = this.createForm(this.data)
    this.isEdit = this.data.id !== '0';
  }

  async ngOnInit () {
    this._adapter.setLocale('pt');
  }

  createForm (data: any) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      name: new FormControl(data.name, [ Validators.required ]),
      city: new FormControl(data.city, [ Validators.required ]),
      state: new FormControl(data.state, [ Validators.required ]),
      ci: new FormControl(data.ci, [ Validators.required ]),
      ccv: new FormControl(data.ccv, [ Validators.required ])
    });

    return form
  }

}
